import React, { useEffect, useState } from "react";

import Button from "../../Forms/Button";
import Modal from 'react-modal';

import './Notifications.dialog.scss'
import { ProfileQL } from "../../../models/Profile";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        border: 'none',
        padding: '0px',
        transform: 'translate(-50%, -50%)',
        overflow: 'visible',
        background: 'transparent',
        boxShadow: '3px 4px 15px rgba(170, 170, 208, 0.5)',
    }
};
Modal.setAppElement('#root');


interface NotifyModalProps {
    profile: ProfileQL['amazonProfile'];
}

function DisconectedModal({ profile }: NotifyModalProps) {

    const [displayNotify, setDisplayNotify] = useState(false);

    useEffect(() => {
        if (!!profile) {
            if (!!profile._id && !profile.mwsSelledId) {
                setDisplayNotify(true);
            }
        }
    }, [profile])

    const reconnect = () => {
        const appId = `amzn1.sellerapps.app.b5727cc3-3fe4-4e1c-8232-2fe1588ec686`;
        const appRedirect = `https://apimws.fiscalpop.com/spconsent`

        window.location.replace(`https://sellercentral.amazon.com.mx/apps/authorize/consent?application_id=${appId}&state=${profile._id}&redirect_uri=${appRedirect}`)
    }

    const closeModal = () => {
        setDisplayNotify(false);
    }

    const renderReconnectNotify = () => {
        return (
            <div id="_FiscalpopNotify">
                <div className="header">
                    <h4>
                        Reconectar con Amazon
                    </h4>
                </div>
                <div className="body">
                    <p>
                        Se detectó que su cuenta no esta correctamente conectada con Amazon Seller Central.
                    </p>
                    <p>
                        Elija "Reconectar" para otorgar permisos en Seller Central y poder facturar.
                    </p>
                </div>
                <div className="action">
                    <Button tertiary={true} handleClick={closeModal}>
                        <span>
                            Lo haré después
                        </span>
                    </Button>
                    <Button primary={true} handleClick={reconnect}>
                        <span>
                            Reconectar
                        </span>
                    </Button>
                </div>
            </div>
        )
    }

    return (
        <Modal
            isOpen={displayNotify}
            onRequestClose={closeModal}
            style={customStyles}
            shouldCloseOnEsc={true}
            shouldCloseOnOverlayClick={true}
            closeTimeoutMS={500}
            contentLabel="FiscalPOP reconnect"
        >
            {renderReconnectNotify()}
        </Modal>
    )

}

export default DisconectedModal;